import { useEffect } from 'react';
import Dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { Lock } from '@mui/icons-material';

import { OpenCloseDialogLead } from 'store/actions/schoolDetailActions';
import { AddLead } from 'store/actions/studentActions';

import { loadState } from 'utils/localStorage';
import { showScheduledButton } from 'utils/lead';

const ScheduledMeetingButtonComponent = Dynamic(() =>
  import('components/SchoolsComponents/ScheduledMeetingButtonComponent')
);

UnlockEstimateComponent.propTypes = {
  buttonText: PropTypes.string,
};

UnlockEstimateComponent.defaultProps = {
  buttonText: 'Desbloquear',
};

export default function UnlockEstimateComponent({ buttonText }) {
  const state = loadState();
  const lead = state?.lead || {};
  const dispatch = useDispatch();

  useEffect(() => {
    if (lead) AddLead(dispatch, lead);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (showScheduledButton(lead)) return <ScheduledMeetingButtonComponent />;

  return (
    <Button
      sx={{
        color: 'white',
        backgroundColor: 'green',

        '&:hover': {
          backgroundColor: '#005b00',
        },
      }}
      variant="contained"
      onClick={() => OpenCloseDialogLead(dispatch, true)}
    >
      <Lock />
      &nbsp;{buttonText}
    </Button>
  );
}
